import React from "react";

import { useIntl } from "react-intl";

import noData from "@app/assets/dataView/noData.svg";

import messages from "../../messages";

import styles from "./NoData.module.scss";

interface Props {}

const NoData: React.FC<Props> = () => {
  const intl = useIntl();

  return (
    <div className={styles.container}>
      <img alt="no-data" className={styles.noDataImage} src={noData} />
      <div className={styles.noData}>{intl.formatMessage(messages.noData)}</div>
      <div className={styles.noDataDescription}>
        {intl.formatMessage(messages.noDataDescription)}
      </div>
    </div>
  );
};

export default NoData;
